// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/data_health.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetDataHealthRequest, GetDataHealthResponse } from "./data_health_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * DataHealthService answers «can I trust today's numbers?» for the caller's
 * workspace: the path of a click (site → queue → journal → reports → partner),
 * what is losing money now, and coverage. Board «Здоровье данных» (Health)
 * and the footer health line (Foot) read only this. Alerts read the same
 * facts from Prometheus (tracker_edge_*), so the screen and Mattermost agree.
 *
 * @generated from service tracker.v1.DataHealthService
 */
export const DataHealthService = {
  typeName: "tracker.v1.DataHealthService",
  methods: {
    /**
     * @generated from rpc tracker.v1.DataHealthService.GetDataHealth
     */
    getDataHealth: {
      name: "GetDataHealth",
      I: GetDataHealthRequest,
      O: GetDataHealthResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

